var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Sesión Expirada","modal-class":"modal-danger","gradient":"danger","hide-footer":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',[_vm._v("Token no presente. Serás redirigido al login.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }